import type { StyleRule } from '@archipro-design/aria';
import {
    accordionTitleSlotClassNames,
    buttonClassName,
} from '@archipro-design/aria';
import { accordionClassName } from '@archipro-design/aria';
import { accordionTitleCustomSlotClassNames } from '@archipro-design/aria';
import {
    pxToRem,
    categorySelectorSlotClassNames,
    labelClassName,
    accordionSlotClassNames,
} from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const FilterNavigation: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(2),
    [`& .${categorySelectorSlotClassNames.category}`]: {
        [`& .${labelClassName}`]: {
            fontWeight: 500,
        },
        [`& .${svgIconClassName}`]: {
            opacity: 0,
        },
    },
    [`& .${categorySelectorSlotClassNames.category}:hover`]: {
        [`& .${svgIconClassName}`]: {
            opacity: 1,
        },

        [`& .${labelClassName}`]: {
            textDecoration: 'underline',
            textUnderlineOffset: pxToRem(3),
        },
    },
    [`& .${accordionClassName}`]: {
        borderWidth: '1px',
        [`& .${accordionSlotClassNames.title}`]: {
            paddingTop: pxToRem(13.5),
            paddingRight: 0,
            borderWidth: '1px',
            [`& .${accordionTitleSlotClassNames.contentWrapper}`]: {
                [`> :not(.${accordionTitleCustomSlotClassNames.titleIndicator})`]:
                    {
                        marginBottom: pxToRem(16),
                        height: pxToRem(22),
                    },

                [`& .title`]: {
                    fontSize: pxToRem(20),
                    letterSpacing: 0,
                    lineHeight: pxToRem(27),
                    fontWeight: '500',
                },
            },
        },
    },

    [`& .${categorySelectorSlotClassNames.backButton}`]: {
        [`&.${buttonClassName}`]: {
            marginBottom: pxToRem(16),

            [`& .${labelClassName}`]: {
                fontWeight: theme.siteVariables.fontWeightLight,
            },
            [`& .${svgIconClassName}`]: {
                width: pxToRem(12),
                height: pxToRem(12),
            },
        },
    },
});

export const FilterSectionTitle: StyleRule = ({ theme }) => ({
    fontSize: theme.siteVariables.fontSizes.caption03,
    lineHeight: theme.siteVariables.lineHeightSmall,
    letterSpacing: 0,
    marginBottom: pxToRem(30),
    height: 'auto',
    color: theme.siteVariables.colorScheme.default?.foreground,
});
